import { dimensions, SvgIconProps } from "./SvgIcon";

export const DateRangeIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2V0.5C10 0.367392 9.94732 0.240215 9.85355 0.146447C9.75979 0.0526784 9.63261 0 9.5 0L8.5 0C8.36739 0 8.24021 0.0526784 8.14645 0.146447C8.05268 0.240215 8 0.367392 8 0.5V2H4V0.5C4 0.367392 3.94732 0.240215 3.85355 0.146447C3.75979 0.0526784 3.63261 0 3.5 0L2.5 0C2.36739 0 2.24021 0.0526784 2.14645 0.146447C2.05268 0.240215 2 0.367392 2 0.5V2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4L0 10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V4C12 3.46957 11.7893 2.96086 11.4142 2.58579C11.0391 2.21071 10.5304 2 10 2ZM10 10H2V5H10V10Z"
        fill="currentColor"
      />
    </svg>
  );
};
